import { gql } from '@apollo/client';

const LoanDatatableFragments = {
  loan: gql`
    fragment LoanDatatableLoan on Loan {
      __typename
      id
      account_id
      borrower_credit_score
      company {
        id
      }
      current_balance_cents
      original_balance_cents
      interest_rate_bps
      servicing_rate_bps
      first_payment_date
      product
      maturity_date
      age_months
      remaining_loan_terms_months
      state
      listing {
        id
        name
        ... on UserCompanyListing {
          name
        }
      }
      pools {
        id
        name
        asset_class
        loan_count
        ... on UserCompanyListing {
          name
        }
      }
      ... on AutoLoan {
        auto_original_value_cents
        auto_vin
        ltv_bps
        dti_bps
      }
      ... on HomeLoan {
        city
        cra
        dti_bps
        ltv_bps
        occupancy
        purpose
        irap_months
        rap_months
        periodic_cap_rate_bps
        lifetime_cap_rate_bps
        lifetime_floor_rate_bps
        interest_only
        io_period_months
        amortization_term_months
        balloon_term_months
        arm_margin_bps
        arm_index
        arm_index_rate_bps
      }
      ... on UnsecuredPersonalLoan {
        dti_bps
        purpose
      }
      last_updated_date
    }
  `,
  performanceSummary: gql`
    fragment LoanDatatablePerformanceSummary on PerformanceSummary {
      loanCount: loan_count
    }
  `,
};

export default LoanDatatableFragments;
